// Core
import { BlitzDiagram } from './core/BlitzDiagram';
import { DiagramComponent } from './core/DiagramComponent';
import { componentRegistry } from './core/ComponentRegistry';

// Validation
import { SchemaValidator } from './validation/SchemaValidator';
import type { ValidationResult, ValidationError } from './validation/SchemaValidator';

// Schemas - for AI agents and external validators
export * as schemas from './schemas/index';

// Components
import { Diagram } from './components/Diagram';
import { Point, MovablePoint, Line, Circle, Square, Grid as GeometricGrid, Text } from './components/geometric/index';
import { TenFrame } from './components/educational/TenFrame';
import Bin from './components/educational/Bin';
import DraggableDot from './components/educational/DraggableDot';
import DropBin from './components/educational/DropBin';
import DotPool from './components/educational/DotPool';
import { Slider } from './components/interactive/Slider';
import GridLayout from './components/layout/Grid';

// Register all components
componentRegistry.register('point', Point);
componentRegistry.register('movablepoint', MovablePoint);
componentRegistry.register('line', Line);
componentRegistry.register('circle', Circle);
componentRegistry.register('square', Square);
componentRegistry.register('rectangle', Square); // Alias
componentRegistry.register('geometricgrid', GeometricGrid);
componentRegistry.register('text', Text);
componentRegistry.register('tenframe', TenFrame);
componentRegistry.register('bin', Bin);
componentRegistry.register('draggabledot', DraggableDot);
componentRegistry.register('dropbin', DropBin);
componentRegistry.register('dotpool', DotPool);
componentRegistry.register('slider', Slider);
componentRegistry.register('gridlayout', GridLayout);

// Diagram container
componentRegistry.register('diagram', Diagram);
componentRegistry.register('2d', Diagram);
componentRegistry.register('3d', Diagram);

// Auto-register web component AFTER all registrations are complete
if (typeof window !== 'undefined' && typeof customElements !== 'undefined') {
  if (!customElements.get('blitz-diagram')) {
    customElements.define('blitz-diagram', BlitzDiagram);
  }
}

// Export for direct use
export {
  BlitzDiagram,
  DiagramComponent,
  componentRegistry,
  SchemaValidator,
  // Type exports for TypeScript users
  ValidationResult,
  ValidationError,
};

// Export as default for UMD bundle
export default {
  BlitzDiagram,
  DiagramComponent,
  componentRegistry,
  SchemaValidator,
};
